export const loadSmartTablePage = () => import("@/routes/smart-table/page");

export const preloadSmartTablePage = (): void => {
  void loadSmartTablePage();
};
